module.exports = __webpack_public_path__ + "static/media/chatIcon.76f9ec12.svg";